<template lang="pug">
  .container
    .content
      h2 Olá {{capitalizeNames(nomeUsuario)}},
      h2 Seja bem vindo(a) ao Módulo de Gestão de Demandas !
      h2 Através deste Módulo, você conseguirá gerenciar suas atividades e realizar seus fluxos de trabalho com total confiança.
      el-button(
        @click="criarPainel"
      ) Criar meu primeiro painel
    .content
      img.imagem(src="~@/assets/images/bemVindoDemandas.png")

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    nomeUsuario () {
      return this.usuario.pessoa.pessoaFisica.nome
    }
  },

  methods: {
    criarPainel () {
      this.$emit('openModal')
    },
    ucwords (entrada) {
      const regex = /^(.)|\s+(.)|'+(.)/g
      return (entrada.toLowerCase()).replace(regex, function ($1) { return $1.toUpperCase() })
    },
    capitalizeNames (entrada) {
      var capitalized = []
      var nomeArray = this.ucwords(entrada).split(' ')
      var articleAndPrepositions = ['El', 'La', 'Le', 'Les', 'Los', 'Os', 'A', 'As', 'E', 'Da', 'De', 'Di', 'Do', 'Du', 'Das', 'Dos', 'Deu', 'Der', 'Van', 'Von', 'Bin', 'Della']
      nomeArray.forEach(function (nome) {
        if (articleAndPrepositions.indexOf(nome) !== -1) { nome = nome.toLowerCase() }
        capitalized.push(nome)
      })
      return capitalized.join(' ')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/_variables.scss";

.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}

.imagem {
  height: 90%;
  width: 90%;
  min-height: 350px;
  min-width: 350px;
}

.content {
  width: 50%;
  padding: 50px;
}

h2 {
  font-weight: lighter;
  color: $font-color !important;
}

.el-button {
  margin-top: 40px;
  font-size: 18px;
  height: 60px;
  border-radius: 10px;
  color: $color-primary;
  border-color: $color-primary;
}

</style>



// WEBPACK FOOTER //
// src/screens/demandas/components/BemVindo.vue